/**
 * Archivo de constantes de desarrollo
 */
export const constants = {

  //ROUTES
  ROUTE_URL_MY_ACCOUNT: '/su-cuenta',
  ROUTE_URL_LOGIN: '/inicio-sesion',
  ROUTE_URL_CALL_LOG_DETAIL: '/detalle-llamadas',
  ROUTE_URL_ERROR_PAYMENT: '/error-pago',
  ROUTE_URL_SUCCESS_PAYMENT_RECURRENT: '/confirmacion-pago-recurrente',
  ROUTE_URL_ERROR_PAYMENT_RECURRENT: '/error-pago-recurrente',

  ROUTE_URL_OK_PAYMENT: '/confirmacion-pago',
  ROUTE_URL_PARAM_TICKET_DETAIL: "ultimo-detalle",
  ROUTE_URL_PARAM_PORTABILITY: "conservar-numero",
  ROUTE_URL_PARAM_DOCUMENT: "activacion-por-cedula",
  ROUTE_URL_PARAM_PASSAPORT: "activacion-por-pasaporte",
  ROUTE_URL_COMBOS: "/combos",
  ROUTE_URL_BONUS: "/bonos",
  ROUTE_URL_PAYMENT_COMBOS: "/compra-de-combos",

  //ENDPOINT WEBSERVICES
  ENDPOINT_GET_MENU_LIST: "/MenuControllerRESTService/getMenuList",
  ENDPOINT_GET_CAROUSEL_LIST: "/CarruselControllerRESTService/getCarouselList",
  ENDPOINT_GET_BENEFITS_LIST: "/BenefitsControllerRESTService/getBenefitsList",
  ENDPOINT_GET_RATES_LIST: "/RatesControllerRESTService/getRateList",
  ENDPOINT_LOGOUT: "/SessionControllerRESTService/logout",
  ENDPOINT_LOGIN_VALIDATE_USER_INFORMATION: "/MyInformationControllerRESTService/getUserInformationSmallByDocumentId",
  ENDPOINT_LOGIN_SEND_VALIDATION_CODE_SMS: "/SessionControllerRESTService/sendValidationCodeBySMS",
  ENDPOINT_SAVE_ACCEPT_POLICY: "/AcceptUsePeopleDataControllerRESTService/saveAcceptPolicy",
  ENDPOINT_LOGIN_VALIDATE_PIN_CODE: "/SessionControllerRESTService/validateSMSCode",
  ENDPOINT_LOGIN_UPDATE_USER_INFORMATION: "/MyInformationControllerRESTService/updateUserInformation",
  ENDPOINT_TICKET_GET_BY_DOCUMENT_STATES: "/TicketsControllerRESTService/getTicketsByCustomerAccountId",
  ENDPOINT_IS_LOGGED: "/SessionControllerRESTService/isLogged",
  ENDPOINT_VALIDATE_ICC: "/PortabilityControllerRESTService/validateICC",
  PARAMETER_ENDPOINT_VALIDATE_ICC: "?isPreActivatedChip=",
  ENDPOINT_GET_USER_INFO_FROM_STATE_AGENCY_BY_DOCUMENT: "/PortabilityControllerRESTService/getCustomerInformationFromStateAgency",
  ENDPOINT_PORTABILITY_SEND_VALIDATION_CODE_SMS: "/PortabilityControllerRESTService/pinRequest",
  ENDPOINT_PORTABILITY_VALIDATE_CODE_SMS: "/PortabilityControllerRESTService/pinStatus",
  ENDPOINT_PORTABILITY_GET_CITIES: "/ProvinceCityControllerRESTService/getCityList",
  ENDPOINT_PORTABILITY_GET_DOCUMENT_FORMAT: "/DocumentsControllerRESTService/getDocumentByCategory",

  ENDPOINT_GET_BALANCE: "/CallDetailControllerRESTService/prepayBalance",
  ENDPOINT_GET_SUBSCRIPTION: "/FavoritaControllerRESTService/findSubscriptionFavorita",
  ENDPOINT_GET_PAYMENTMETHODFAVORITA: "/FavoritaControllerRESTService/findPaymentMethodFavorita",
  ENDPOINT_POST_UNSUBSCRIBEFAVORITA: "/FavoritaControllerRESTService/unsubscribeFavorita",

  ENDPOINT_GET_TECHNOLOGY_C0VERAGE_LIST: "/CoverageControllerRESTService/getTechnologyCoverageList",
  ENDPOINT_GET_ROAD_COVERAGE: "/CoverageControllerRESTService/getRoadCoverageList",
  ENDPOINT_GET_COVERAGE_ROAD_TECHNOLOGY: "/CoverageControllerRESTService/getCoverageRoadTechnology",

  ENDPOINT_GET_PROVINCE: "/CoverageControllerRESTService/getCoverageProvinceList",
  ENDPOINT_GET_CANTON: "/CoverageControllerRESTService/getCoverageCantonList",
  ENDPOINT_GET_PARISH: "/CoverageControllerRESTService/getCoverageParishList",

  ENDPOINT_POST_FINDINVOICESFAVORITA: '/FavoritaControllerRESTService/findInvoicesFavorita',
  ENDPOINT_POST_FINDDATAINVOICEFAVORITA: '/FavoritaControllerRESTService/findDataInvoiceFavorita',
  ENDPOINT_GET_RECURRENCEFORM: "/RecurrencePaymentManagerControllerRESTService/getRecurrenceForm",


  ENDPOINT_POST_CHANGEPRODUCTFAVOR: "/FavoritaControllerRESTService/changeProductFavorita",

  ENDPOINT_CALL_LOG_DETAIL_GET_INPUT_OUTPUT_VALUES: "/CallDetailControllerRESTService/getInOutPutValues",
  ENDPOINT_CALL_LOG_DETAIL_REQUEST: "/CallDetailControllerRESTService/sendCallDetailRequest",
  ENDPOINT_GET_COMBO_RECOMMENDED: "/CombosControllerRESTService/getCombosList",
  ENDPOINT_GET_BONUS_RECOMMENDED: "/BonusesControllerRESTService/getBonusesList",
  ENDPOINT_PORTABILITY_REQUEST: "/PortabilityControllerRESTService/sendPortabilityRequest",
  ENDPOINT_VALIDATE_IMEI: "/PortabilityControllerRESTService/validateImei",
  ENDPOINT_GET_ALL_USER_LINES: "/ReleaseControllerRESTService/getAllUserLines",
  ENDPOINT_GET_IMEI_LINES: "/ReleaseControllerRESTService/getBasicDataFromEquipment",
  ENDPOINT_RELEASE_REQUEST: "/ReleaseControllerRESTService/sendReleaseRequest",
  ENDPOINT_RELEASE_VALIDATE_QUESTIONS: "/ReleaseControllerRESTService/validateReleaseQuestions",
  ENDPOINT_SUSPEND_REQUEST: "/SuspensionControllerRESTService/sendSuspensionRequest",
  ENDPOINT_CHANGE_NUMBER_REQUEST: "/NumberChangeControllerRESTService/sendNumberChangeRequest",
  ENDPOINT_CHANGE_CHIP_REQUEST: "/ChipChangeControllerRESTService/sendChipChangeRequest",
  ENDPOINT_RELEASE_LINE_VALIDATION_QUESTIONS: "/ReleaseControllerRESTService/getReleaseQuestions",
  ENDPOINT_TICKET_REQUEST: "/TicketsControllerRESTService/createTicket",
  ENDPOINT_RECHARGE_ALLOWED_VALUES: "/RechargeControllerRESTService/getRechargeValuesList",
  ENDPOINT_RECHARGE_STORED_CARDS: "/PaymentGatewayControllerRESTService/getCreditCardByIdentification",
  ENDPOINT_RECHARGE_DELETE_STORED_CARDS: "/PaymentGatewayControllerRESTService/deleteCreditCardSaved",
  ENDPOINT_RECHARGE_GET_FORM: "/PaymentGatewayControllerRESTService/getPaymentFormConfiguration",
  ENDPOINT_PAYMENT_CANCEL_ASYNC: "/PaymentGatewayControllerRESTService/sendQueueCancelAsinc",
  ENDPOINT_TICKET_GET_CATEGORIES: "/TicketsControllerRESTService/getTicketCategoryList",
  ENDPOINT_BALANCES_AND_BOLTON: "/ManageBalanceOperationsRESTService/getOCSBalancesAndBoltons",
  ENDPOINT_GET_HELP_TOPICS: "/FQSControllerRESTService/getFrequentQuestionByValueList",
  ENDPOINT_VALIDATE_PHONE_IN_BRAND: "/MyInformationControllerRESTService/validatePhoneInBrand",
  ENDPOINT_COMBOS_CONTRACT_TOPUP_BALANCE: "/ContractControllerRESTService/contractByTopUpBalance",
  ENDPOINT_IMGS_MOVISTAR_PLAY: "/MovistarPlayControllerRESTService/getMovistarPlayImgs",
  ENDPINT_TERMS_CONDITIONS: "/TermsCondControllerRESTService/getTermsCondList",
  ENDPINT_TERMS_WITHOUT_CATEGORY: "/TermsCondControllerRESTService/getTermsCondListWithoutCategory",
  ENDPOINT_POLICIES: "/PoliticaPrivacidadDatosControllerRESTService/getAllPolicy",
  ENDPOINT_GROUP_POLICIES: "/ParamControllerRESTService/getListParamGroups?group=",
  ENDPOINT_EXERCISERIGHT: "/DutyPracticeControllerRESTService/getDutyPratice",
  ENDPOINT_SWITCH_RECURRENCE_CONFIG: "/RecurrencePaymentManagerControllerRESTService/getRecurrenceConfigParam",
  ENDPOINT_NORMATIVE: "/NormativeControllerRESTService/getAllNormative",
  ENDPOINT_OTHER_DOCUMENTS: "/OtherDocumentsControllerRESTService/getAllOtherDocuments",

  //VALUE COMBOS
  VALID_COMBO_RECURRENT: "7.99",


  //MAPS
  TYPE_GM_2G: "2G-GSM",
  TYPE_UMTS_3G: "3G-UMTS",



  //COMMONS
  SUCCESS_WS_RESPONSE_CODE: "00",
  ERROR_UNEXPECTED: "-1",
  SESSION_DUPLICATE: "-18",
  NO_DATA_FOUND_WS_RESPONSE_CODE: "-4",
  RELEASE_NO_KEY: "-7",
  PAYMENT_TX_IN_PROCESS_WS_RESPONSE_CODE: "-20",
  PAYMENT_NO_VALID_OFFER_WS_RESPONSE_CODE: "-25",
  LOGIN_RETRY_LIMIT_CODE: "-30",
  CATEGORY_HOME: "HOME",
  CATEGORY_PUBLIC: "PUBLICO",
  CATEGORY_PROMOS: "PROMOCIONES",
  CATEGORY_PORTABILIDAD: "PORTABILIDAD",
  CATEGORY_RATES_ALL: "TODO",
  FROM_RELOAD_PAGE: "RECARGAS",
  FROM_BONOS_PAGE: "BONOS",
  FROM_COMBOS_PAGE: "COMBOS",
  BASE64_INIT: "data:image/jpeg;base64,",
  BASE64_SVG: "data:image/svg+xml;charset=utf-8;base64,",
  BASE64_PDF_FILE: "data:file/pdf;base64,",
  ERROR_TICKETS_LIMIT_CREATED_NUMBER: "-40",
  IMEI_TITLE: "IMEI:",
  MENU_CATEGORY_PUBLIC: "PUBLICO",
  TYPE_CED: "CED",
  TYPE_PAS: "PAS",
  TYPE_RUC: "RUC",
  TYPE_RUP: "RUP",
  SUSPENSION_CODE: "S",
  RELEASE_CODE: "L",
  STRING_LINE: "LINEA",
  STRING_EQUIP: "EQUIPO",
  STRING_LINE_EQUIP: "LINEA_EQUIPO",
  INCOMING: "ENTRANTES",
  OUTCOMING: "SALIENTES",
  YES: "S",
  PAYMENT_TX_INSUFFICIENT_RECHARCHE_CODE: "-6",
  YEAR_MAX_LIMIT: 18,
  STRING_TRUE: "true",
  NUMBER_10: "10",

  //TICKET STATES
  STATE_ASIGNED: "ASIGNADO",
  STATE_PROGRESS: "PROGRESO",
  STATE_ONHOLD: "ONHOLD",
  STATE_FINISHED: "RESUELTO",
  STATE_CLOSED: "CERRADO",
  STATE_CANCELED: "CANCELADO",
  TICKET_TOPIC_LIST: [{ "id": "9150872863813654791", "name": "Asunto 1" }, { "id": "9150872863813654791", "name": "Asunto 2" }, { "id": "9150872863813654791", "name": "Asunto 3" }],

  //REGEX VALIDATIONS
  REGEX_NUMERIC_PATTERN: "^[0-9]*$",
  REGEX_PHONE_PATTERN: "^[0-9]{9,10}$",
  REGEX_ALPHANUMERIC_PATTERN: "^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9 ]*$",
  REGEX_EMAIL_PATTERN: "^[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\\.)+([A-Za-z0-9]{2,4})$",
  REGEX_DIRECTION: "^[a-zA-Z0-9-_ ]*$",

  //PORTABILITY
  PORTABILITY_DOWNLOAD_FILE_NAME: "Formulario_de_portabilidad.pdf",

  //BalanceAndBolton
  BALANCEANDBOLTON_DOWNLOAD_FILE_NAME: "Factura_MAXI_",
  BALANCEANDBOLTON_DOWNLOAD_FILE_NAME_2: ".pdf",

  //COMBOS-HOME
  COMBOS_ID: "COMBOS",
  COMBOS_BENEFIT_WITHOUT_SOCIAL_NETWORK: "Ninguna",
  SOCIAL_NEKWORK_FACEBOOK: "Faebook",
  SOCIAL_NEKWORK_WHATSAPP: "Whatsapp",
  SOCIAL_NEKWORK_YOUTUBE: "Youtube",
  //CALL LOG
  CALL_LOG_DETAIL_MAX_DAY_ALLOWED: 360,

  //ORDER HISTORY
  ALL_LINES_VALUE: 99,

  //RECHARGE
  PAYMENT_FORM_REST_RECHARGE: "PAYMENT_FORM_REST_RECHARGE",
  MAX_CARD_ALLOWED: 3,
  RECHARGE_FORM_OPCTOKEN: "OPCTOKEN",
  RECHARGE_FORM_OPCTOKEN_OP1: "01",
  RECHARGE_FORM_OPCTOKEN_OP0: "00",

  //COMBOS
  COMBO_CATEGORY_BRAND: "MAXIPLUS",
  COMBO_CATEGORY_MOUNT: "MES",
  COMBO_CATEGORY_EXPRESS: "EXPRESS",
  PAYMENT_FORM_REST_CONTRATATION: "PAYMENT_FORM_REST_CONTRATATION",

  //FOOTER
  URL_PDF_QUALITY_INDICES: "../UtilsMaxiplus/2019_Q2_SMA-O-QoS-5_Parámetros_de_Calidad_General_Abr_-_Jun_2019.pdf",
  URL_PDF_REGULATIONS_HOMOLOGATION_1: "../UtilsMaxiplus/ReglamentosHomologacion/REFORMAS REGLAMENTO HOMOLOGACION Y CERTIFICACION DE EQUIPOS.pdf",
  URL_PDF_REGULATIONS_HOMOLOGATION_2: "../UtilsMaxiplus/ReglamentosHomologacion/REGLAMENTO HOMOLOGACION Y CERTIFICACION DE EQUIPOS.pdf",
  URL_PDF_REGULATIONS_SERVICES: "../UtilsMaxiplus/REGLAMENTO_ABONADOS_SERVICIOS_TELECOMUNICACIONES_Y_VALOR_AGREGADO.pdf",
  URL_PDF_TERMNS_CONDITIONS: "../UtilsMaxiplus/BasesCondiciones/",
  //Files extension available
  ACCEPT_FILES: 'application/pdf, image/JPEG, image/png, image/JPG,  application/msword',
  ACCEPT_IMG_FILES: 'image/*',

  //EXTENSION_FILE_AVAILABLE: [".PDF", ".JPG", ".JPEG", ".PNG", ".DOC", ".DOCX"],
  EXTENSION_FILE_AVAILABLE: [".PDF", ".JPG", ".JPEG", ".PNG"],
  //NORMATIVES PDF
  NORMATIVE_PATH_PDF: "../UtilsMaxiplus/Normativas/",
  NORMATIVE_PDF_1: "Norma técnica que regula las condiciones generales de los contratos de adhesión, del contrato negociado con clientes, y del empadronamiento de abonados y clientes.pdf",
  NORMATIVE_PDF_2: "Reglamento a la ley de defensa del consumidor.pdf",
  NORMATIVE_PDF_3: "Ley orgánica de defensa del consumidor.pdf",
  NORMATIVE_PDF_4: "Procedimiento de devolución de saldos remanentes de recargas.pdf",
  NORMATIVE_PDF_5: "Politica de Privacidad.pdf",

  //USO 911
  URL_PDF_USO_911: "../UtilsMaxiplus/Usa_bien_el_9-1-1.pdf",

  //CODE_SEMILLA
  CODE_IV:'',
  CODE_KP:'',

};